export default __webpack_public_path__ + "static/media/women.f99ab511.svg";